import { ServiceContext } from "./ServiceContext";
import type { Service } from "@/types/Service";

export type ServiceProviderProps = {
  children: React.ReactNode;
  service: Service;
};

export const ServiceProvider = ({
  children,
  service,
}: ServiceProviderProps) => {
  return <ServiceContext value={service}>{children}</ServiceContext>;
};
